const noop = () => {};

export const socketLog: (...args: unknown[]) => void = import.meta.env.DEV
  ? console.log.bind(console)
  : noop;

export const socketDebug: (...args: unknown[]) => void = import.meta.env.DEV
  ? console.debug.bind(console)
  : noop;
